import {
  QuestionItemContainingOpinionQuestionDto,
  QuestionItemContainingOpinionQuestionModel,
} from 'api/dto/new/Common/QuestionItemContainingOpinionQuestion.dto';
import { SummaryItemDto, SummaryItemModel } from 'api/dto/new/Common/SummaryItem.dto';
import { SimpleProject } from 'model/SimpleProject';
import { simpleProjectMapper } from 'container/simpleProjectMapper';
import { SimpleProjectApi } from 'api/SimpleProjectApi';

export type SummaryPulseOnDemandCombinedDto = {
  questions: QuestionItemContainingOpinionQuestionDto[];
  summary: SummaryItemDto;
};

export type SummaryPulseOnDemandCombinedModel = {
  questions: QuestionItemContainingOpinionQuestionModel[];
  summary: SummaryItemModel;
};

export const mapSummaryPulseOnDemandCombinedDtoToSimpleProjectCombine = (
  dto: SummaryPulseOnDemandCombinedDto
): SimpleProject.Combine => {
  // Temporal solution to quickly switch to new API
  return simpleProjectMapper.deserializeCombine((dto as unknown) as SimpleProjectApi.EntryCombine);
};

// TODO: use this mapper later for new endpoint proper typing - https://buzzing.atlassian.net/browse/RPT-257
// export const mapSummaryPulseOnDemandCombinedDtoToModel = (
//   dto: SummaryPulseOnDemandCombinedDto
// ): SummaryPulseOnDemandCombinedModel => {
//   return {
//     questions: dto.questions.map(mapQuestionItemContainingOpinionQuestionDtoToModel),
//     summary: mapSummaryItemDtoToModel(dto.summary),
//   };
// };
